import React from 'react';
import Container from 'components/container';
import PublicLayout from 'components/layouts/Public';
import { PROJECTS_URL } from 'constants/urls';
import { BlogPost } from 'containers/blog';
import { getProjectPost, projectsFeedItems } from 'content/projects';
import { useStaticRouter } from 'utils/useStaticRouter';

const ProjectPage = () => {
  const router = useStaticRouter();
  const { id } = router.query;

  return (
    <PublicLayout>
      <Container centerContent py="20px" pylg="20px">
        {id && <BlogPost id={id as string} getBlogPost={getProjectPost} path={PROJECTS_URL} />}
      </Container>
    </PublicLayout>
  );
};

export const getStaticPaths = async () => {
  return {
    paths: projectsFeedItems.map(({ id }) => ({ params: { id } })),
    fallback: true,
  };
};

export const getStaticProps = async () => {
  return { props: {} };
};

export default ProjectPage;
